<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>For Agnes, who wanted a love story</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?55e3cd19